import { useDispatch } from "react-redux";

import { LoginResponseBodyType } from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { setConfetti, setDialog } from "../../store/slices/global";
import { api } from "../api";

const patchUserWelcome = async (
  showWelcome: boolean,
  id: string,
  organizationId: string,
  email: string
) => {
  const user = { showWelcome, organizationId, email, id };
  const resp = await api.patch<LoginResponseBodyType>(`/v2/users/${id}`, {
    user,
  });
  return resp.data;
};

export const usePatchUserWelcome = () => {
  const dispatch = useDispatch();

  return useMutation({
    mutationKey: ["patchUserWelcome"],
    mutationFn: async (data: {
      showWelcome: boolean;
      userId: string;
      organizationId: string;
      email: string;
    }) => {
      return patchUserWelcome(
        data.showWelcome,
        data.userId,
        data.organizationId,
        data.email
      );
    },
    onSuccess: async () => {
      dispatch(setConfetti(true));
      dispatch(
        setDialog({
          dialog: "onboarding",
          open: false,
        })
      );
    },
    onSettled: async () => {
      dispatch(
        setDialog({
          dialog: "onboarding",
          open: false,
        })
      );
    },
  });
};
